import _ from 'lodash';
import { axiosInstance } from '../helpers/axios';
import { userService } from './user.service';
import { getTemplateManagementRequestParams } from '../utils/templatesList';
import { normalizeTemplateCreateInput } from '../utils/templateForm';

export const templateService = {
  create,
  findAll,
  findManagement,
  getById,
  update,
  updateManagementState,
};

function create(template) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: normalizeTemplateCreateInput(template),
  };

  return axiosInstance
    .post(`/templates`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .then(response => {
      return response;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function findAll(query) {
  return axiosInstance
    .get(`/templates`, { params: query })
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function findManagement(query) {
  return axiosInstance
    .get('/templates/management/list', {
      params: getTemplateManagementRequestParams(query),
    })
    .then(handleResponse);
}

function getById(id) {
  return axiosInstance.get(`/templates/${id}`).then(handleResponse);
}

function updateManagementState(id, changes) {
  return axiosInstance
    .patch(`/templates/management/${id}/state`, changes)
    .then(handleResponse);
}

function update({ id, ...template }) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: template,
  };

  return axiosInstance
    .put(`/templates/${id}`, requestOptions.body, requestOptions.headers)
    .then(handleResponse);
}

const handleResponse = response => {
  const data = response.data;
  if (!_.includes([200, 201, 204], response.status)) {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      userService.logout().then(() => window.location.reload(true));
    }

    const error = (data && data.message) || response.statusText;

    // eslint-disable-next-line no-throw-literal
    throw { status: response.status, error };
  }

  return data;
};
